import Vue from 'vue'
import VueRouter from 'vue-router'
import Error from './components/Error.vue'
import AdminLogin from './components/Login.vue'
import UserManage from './components/UserManagement/UserManage.vue'
import store from '../src/store/manage.store.js'
import { TAB_TITLES } from './components/shared/constants'

Vue.use(VueRouter)

const routes = [
  { 
    path: '/',
    redirect: '/manage'
  },
  { 
    path: '/error',
    component: Error,
    name: 'error',
    meta: {title: TAB_TITLES.errorTitle}
  },
  { 
    path: '/login',
    component: AdminLogin,
    name: 'login'
  },
  { path: '/manage',
    component: UserManage,
    name: 'manage',
    meta: {requiresAuth: true}
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
    next('login')
  }
  else next()
})

router.afterEach(to => {
  Vue.nextTick(() => {
    document.title = to.meta.title || document.title;
  })
})

export default router